setAsset